import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ServiceOfferingCategory } from './service-offering-shop-categories.model';

export interface GenerateServiceOfferingCategoriesOptions {
  readonly id?: number;
  readonly shopId?: number;
  readonly name?: string;
  readonly description?: string;
}

export function generateServiceOfferingCategoryObject({
  id = generateId(),
  shopId = generateId(),
  name,
  description,
}: GenerateServiceOfferingCategoriesOptions): ServiceOfferingCategory {
  return {
    id,
    shopId,
    name: name || `Test Category ${id}`,
    description: description || `Test Category Description ${id}`,
  };
}
